import { Injectable } from '@angular/core';

@Injectable()
export class UrlSignature {
  applicationName = '/techbridge';
  environment = '-dev';
  acdtUrl = 'https://techbridge.edu.gh';
  aucdtUrl = 'https://api.techbridge.edu.gh';
  // baseUrl = this.aucdtUrl + this.applicationName + this.environment;
  baseUrl = "http://localhost:8181";
  addressUrl = this.baseUrl + '/address/';
  advertisingListUrl = this.baseUrl + '/advertisingList';
  applicantUrl = this.baseUrl + '/applicant/';
  certificateProgrammeListUrl = this.baseUrl + '/certificateProgrammeList';
  certificatesUrl = this.baseUrl + '/certificates';
  certificationUrl = this.baseUrl + '/certification';
  cityByIdUrl = this.baseUrl + '/city/';
  cityIdByCountryUrl = this.baseUrl + '/cityId/city/';
  cityListForCountry = this.baseUrl + '/cityByCountry/country/';
  congratulationEmail = this.baseUrl + '/sendCongratulationMail';
  contactByIdUrl = this.baseUrl + '/contact/';
  contactUrl = this.baseUrl + '/person/contact/';
  countryUrl = this.baseUrl + '/country/';
  countryListUrl = this.baseUrl + '/countryCodes';
  countryNameUrl = this.baseUrl + '/countryByCity/city/';
  courseListUrl = this.baseUrl + '/course';
  currentDateUrl = this.baseUrl + '/currentDate';
  currentYearUrl = this.baseUrl + '/currentYear';
  declarationUrl = this.baseUrl + '/declaration';
  deleteResultsUrl = this.baseUrl + '/deleteFile/results';
  enquiryUrl = this.baseUrl + '/emailEnquiry';
  examinationListUrl = this.baseUrl + '/examinationList';
  examinationSubjectsUrl = this.baseUrl + '/examinationSubjects';
  examinationUrl = this.baseUrl + '/examinations';
  financeOptionsUrl = this.baseUrl + '/financingOption';
  financingDetailsUrl = this.baseUrl + '/financing';
  genderListUrl = this.baseUrl + '/genderList';
  getPasswordUrl = this.baseUrl + '/getPassword';
  getSignUpUrl = this.baseUrl + '/signUp/';
  institutionUrl = this.baseUrl + '/institutions/';
  pdfUrl = this.baseUrl + '/pdf';
  personByIdUrl = this.baseUrl + '/personId/';
  personUrl = this.baseUrl + '/person/userName/';

  personAuthUrl = this.baseUrl + '/person/auth';

  admissionLetterUrl = this.acdtUrl + '/attachments' + this.environment + '/admission-letters/';
  photoLinkUrl = this.acdtUrl + '/attachments' + this.environment + '/passports/';
  portfolioAttachmentUrl = this.acdtUrl + '/attachments' + this.environment + '/results/';
  portfolioListUrl = this.baseUrl + '/portfolio';
  previousEnrollmentByIdUrl = this.baseUrl + '/previousEnrollment/';
  programmeListUrl = this.baseUrl + '/programme';
  programmeTypesUrl = this.baseUrl + '/programmeTypes';
  regionListUrl = this.baseUrl + '/regionList';
  religionListUrl = this.baseUrl + '/religion';
  saveContactUrl = this.baseUrl + '/contact';
  savePermanentAddressUrl = this.baseUrl + '/permanentAddress';
  savePersonOnlyUrl = this.baseUrl + '/personOnly';
  savePersonUrl = this.baseUrl + '/person';
  savePostalAddressUrl = this.baseUrl + '/postalAddress';
  saveSignupUrl = this.baseUrl + '/signup';
  sendEmailURL = this.baseUrl + '/sendMail';
  senderEmailId = 'admin_dev@techbridge.edu.gh';
  sendTokenUrl = this.baseUrl + '/token/';
  sponsorDetailsUrl = this.baseUrl + '/sponsor';
  subjectDetailsUrl = this.baseUrl + '/subject';
  subjectsUrl = this.baseUrl + '/subjects/';
  titleListUrl = this.baseUrl + '/titleList';
  updatePasswordUrl = this.baseUrl + '/update/password/';
  uploadFileUrl = this.baseUrl + '/uploadFile/';
  validateTokenUrl = this.baseUrl + '/token/validity/';
  warningMessageUrl = this.baseUrl + '/previousEnrollment/warningMessage/';

  // New payment & Admissions APIs;
  paymentsignupUrl = this.baseUrl + '/api/payment-signup/register';
  paymentsignupverificationUrl = this.baseUrl + '/api/payment-signup/verify';
  paymentsignupotpresendUrl = this.baseUrl + '/api/payment-signup/resend-otp';
  generatereportapplicantreport = this.baseUrl + '/api/report/';
  loginpaymenturl = this.baseUrl + '/api/payment-applicant/login';
  makepayment = this.baseUrl + '/api/payments/initiate';
  paymentverificationstatusurl = this.baseUrl + '/api/payments/verify-status'
  paymentsuccessurl = this.baseUrl + '/api/payments/success-get-credentials';
  referencepinloginurl = this.baseUrl + '/api/auth/reference-pin-login';
  applicantdashboardinitialinformationurl = this.baseUrl + '/api/applicant-admissions/applicant-data';
  applicationstatusurl = this.baseUrl + '/api/applicant-admissions/application-status';
  saveandupdateapplicantinfourl = this.baseUrl + '/api/applicant-admissions/applicant-update';
  uploaddocumenturl = this.baseUrl + '/api/applicant-admissions/upload-document';
  retrievedocumenturl = this.baseUrl + '/api/applicant-admissions/documents/simple';
  refreshTokenUrl = this.baseUrl + '/api/auth/refresh-token';

  // resetpassword
   sendlinkforforgotpasswordUrl= this.baseUrl + '/api/payment-signup/forgot-password'
  resetPasswordUrl = this.baseUrl + '/api/payment-signup/reset-password'
 
}
